'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002eeventbus$002e$002dWrite$002dBus from "./com.raquo.airstream.eventbus.-Write-Bus.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBus() {
  this.E2 = null;
  this.fr = null;
  this.rB = null;
  this.E2 = (void 0);
  this.fr = new $j_com$002eraquo$002eairstream$002eeventbus$002e$002dWrite$002dBus.$c_Lcom_raquo_airstream_eventbus_WriteBus(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this))), ".writer");
  this.rB = this.fr.lv;
}
export { $c_Lcom_raquo_airstream_eventbus_EventBus as $c_Lcom_raquo_airstream_eventbus_EventBus };
$p = $c_Lcom_raquo_airstream_eventbus_EventBus.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_EventBus;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBus() {
}
export { $h_Lcom_raquo_airstream_eventbus_EventBus as $h_Lcom_raquo_airstream_eventbus_EventBus };
$h_Lcom_raquo_airstream_eventbus_EventBus.prototype = $p;
$p.dP = (function() {
  return this.E2;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.lh = (function() {
  return this.fr;
});
$p.dS = (function() {
  return this.rB;
});
var $d_Lcom_raquo_airstream_eventbus_EventBus = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_eventbus_EventBus, "com.raquo.airstream.eventbus.EventBus", ({
  gW: 1,
  a1: 1,
  ba: 1,
  aP: 1,
  M: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_EventBus as $d_Lcom_raquo_airstream_eventbus_EventBus };
